/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import firebase from '@/firebase/firebase';

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    isNewUser({commit}, payload) {
      commit('IS_NEW_USER_ACCOUNT', payload)
    },

    updateCompanyInfo({ commit }, payload) {
      commit('UPDATE_COMPANY_INFO', payload)
    },

    updateCompanyFiscal({ commit }, payload) {
      commit('UPDATE_COMPANY_FISCAL', payload)
    },

    updateCompanyAddress({commit}, payload) {
      commit('UPDATE_COMPANY_ADDRESS', payload)
    },

    updateCompanyAllowAskForHelp({commit}, payload) {
      commit('UPDATE_COMPANY_ALLOW_ASK_FOR_HELP', payload)
    },

    updateCompanyId({ commit }, payload) {
      commit('UPDATE_COMPANY_ID', payload)
    },

    updateCompanyRazaoSocial ({ commit }, payload) {
      commit('UPDATE_COMPANY_RAZAO_SOCIAL', payload)
    },

    updateUserInfo({ commit }, payload) {
      if(!payload.hasOwnProperty('notify')) {
        payload = { ...payload, ...{ notify : { newBill : false, newOrder : false, waiter : true } } }
      }
      commit('UPDATE_USER_INFO', payload)
    },

    updateUserName({commit}, payload) {
      commit('UPDATE_USER_NAME', payload)
    },

    updateUserPhoto({commit}, payload) {
      commit('UPDATE_USER_PHOTO', payload)
    },

    updateUserNotifyOrders ({commit}, payload) {
      commit('UPDATE_USER_NOTIFY_ORDERS', payload)
    },
    updateUserNotifyBill ({commit}, payload) {
      commit('UPDATE_USER_NOTIFY_BILL', payload)
    },
    updateUserNotifyWaiter ({commit}, payload) {
      commit('UPDATE_USER_NOTIFY_WAITER', payload)
    },

    updateUserCPF({commit}, payload) {
      commit('UPDATE_USER_CPF', payload)
    },

    updateUserPhone({commit}, payload) {
      commit('UPDATE_USER_PHONE', payload)
    },

    updateUserPhoto({ commit }, payload) {
      commit('UPDATE_USER_PHOTO', payload)
    },

    updateUserCompanyId({ commit }, payload) {
      commit('UPDATE_USER_COMANY_ID', payload)
    },

    flashMessage({ commit }, payload) {
      commit('FLASH_MESSAGE', payload)
    },

    logout({ commit }) {
      commit('LOGOUT_USER')
    },

    async logUserInCompany ({ dispatch, getters }, companyId) {
      const userId = getters.getUserStoredData.id;
      const firestore = firebase.firestore();
      
      const companyUserRef = firestore.collection(`/company/${companyId}/companyUsers`).doc(userId);
      const companySnap = await firestore.collection('company').doc(companyId).get();
      const companyUser = await companyUserRef.get() 

      await Promise.all([
        dispatch('updateCompanyId', companyId),
        dispatch('updateCompanyInfo', companySnap.data()),
        dispatch('updateUserInfo', companyUser.data()),
        companyUserRef.update({ lastLoginAt : new Date() }, { merge : true }),
      ]);
    }
}

export default actions
